import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import TopShipping from "../../../../Components/ComponentsIndustry/TopShipping";
import SubHeader from "../../../../Components/ComponentsIndustry/SubHeader";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import axios from 'axios';
import React, { useEffect, useState } from "react";
import { useSausage } from "../../../../providers/SausageContext";

import {
  Container,
  ContainerCard,
  SizeContainer,
  MainContainer,
  SubTitle,
  TotalsContainer,
  TotalsDifferent,
  NegociationAproved,
  RequestContainer,
  FirstRequestContainer,
  ButtonContainer,
  Header,
  MiddleContent,
  Footer
} from "./style";
import { useCommercialSales } from "../../../../providers/CommercialSalesContext";
import { useUser } from "../../../../providers/UserContext";

const ToolsShippingSausage = () => {

  const { approvedNegociations, getApprovedNegociation } = useCommercialSales()
  const { rodada } = useUser()

  const [inCash, setInCash] = useState(true);
  const [thirtyDays, setThirtyDays] = useState(false);
  const [caixas, setCaixas] = useState(0)
  const [alertTruck, setAlertTruck] = useState('')
  const [alert3x4, setAlert3x4] = useState('')
  const [alertCarreta, setAlertCarreta] = useState('')

  const handleDeadline = (sub) => {
    switch (sub) {
      case "inCash":
        setInCash(true);
        setThirtyDays(false);
        break;
      case "thirtyDays":
        setInCash(false);
        setThirtyDays(true);
        break;
      default:
        break;
    }
  };

  const arrayFrotas = [
    {
      "cargaCaixas": 0.3,
      "cargaKg": 4000,
      "custoTotal": 0,
      "custoViagem": 950,
      "viagens": 0,
      "img": "shipping_1.svg"
    },
    {
      "cargaCaixas": 0.63,
      "cargaKg": 12000,
      "custoTotal": 0,
      "custoViagem": 2000,
      "viagens": 0,
      "img": "shipping_2.svg"
    },
    {
      "cargaCaixas": 0.94,
      "cargaKg": 24000,
      "custoTotal": 0,
      "custoViagem": 3000,
      "viagens": 0,
      "img": "shipping_3.svg"
    }
  ]

  const [frota3x4, setFrota3x4] = useState(0);
  const [frotaTruck, setFrotaTruck] = useState(0);
  const [frotaCarreta, setFrotaCarreta] = useState(0);
  const [qtdSelecionada, setQtdSelecionada] = useState(0);
  const [qtdSelecionadaTruck, setQtdSelecionadaTruck] = useState(0);
  const [qtdSelecionadaCarreta, setQtdSelecionadaCarreta] = useState(0);
  const [caixasRestantes, setCaixasRestantes] = useState(0)
  const [selectedMarketNegociation, setSelectedMarketNegociation] = useState({})

  const handleShipping = () => {
    const data = {
      "cam3x4CargaCaixas": 0,
      "cam3x4CargaKg": 0,
      "cam3x4CustoTotal": 0,
      "cam3x4CustoViagem": 0,
      "cam3x4Viagens": 0,
      "camCarretaCargaCaixas": 0,
      "camCarretaCargaKg": 0,
      "camCarretaCustoTotal": 0,
      "camCarretaCustoViagem": 0,
      "camCarretaViagens": 0,
      "camTruckCargaCaixas": 0,
      "camTruckCargaKg": 0,
      "camTruckCustoTotal": 0,
      "camTruckCustoViagem": 0,
      "camTruckViagens": 0,
      "codProduto": 7,
      "codRodada": rodada.rodada,
      "logistica": 0
    }

    axios({
      method: "POST",
      url: "https://sistemas.sisinfor.com.br/BusinessGameBack/api/logistica/cadastrar",
      data: data
    })
      .then(response => console.log(response))
  }

  const handleFrota3x4 = (e) => {
    setFrota3x4(e.target.value)

    if (e.target.value >= 1) {

      if (e.target.value > frota3x4) {

        if (caixasRestantes > arrayFrotas[0]?.cargaKg) {
          if (qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value) > caixas) {
            setQtdSelecionada(caixas)
            setAlert3x4(`Há ${(qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value) - caixas) / 1000} ton remanescentes nas frotas contratadas`)
          } else {
            setAlert3x4("")
            setQtdSelecionada(qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value))
          }
          setCaixasRestantes(caixasRestantes - (arrayFrotas[0]?.cargaKg * e.target.value) > caixasRestantes ? 0 : caixasRestantes - (arrayFrotas[0]?.cargaKg * e.target.value))
        } else {
          setQtdSelecionada(qtdSelecionada + caixasRestantes)
          setCaixasRestantes(0)
        }

      } else {

        if (caixasRestantes > arrayFrotas[0]?.cargaKg) {
          if (qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value) > caixas) {
            setQtdSelecionada(caixas)
            setAlert3x4(`Há ${(qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value) - caixas) / 1000} ton remanescentes nas frotas contratadas`)
          } else {
            setAlert3x4("")
            setQtdSelecionada(qtdSelecionada + (arrayFrotas[0]?.cargaKg * e.target.value))
          }
          setCaixasRestantes(caixasRestantes - (arrayFrotas[0]?.cargaKg * e.target.value) > caixasRestantes ? 0 : caixasRestantes - (arrayFrotas[0]?.cargaKg * e.target.value))
        } else {
          setQtdSelecionada(qtdSelecionada + caixasRestantes)
          setCaixasRestantes(0)
        }
      }

    } else {
      setAlert3x4("")
      setQtdSelecionada(0)
      setCaixasRestantes(caixas)
    }

  }

  const handleFrotaTruck = (e) => {
    setFrotaTruck(e.target.value)

    if (e.target.value >= 1) {
      if (e.target.value > frotaTruck) {

        if (caixasRestantes > arrayFrotas[1]?.cargaKg) {
          if (qtdSelecionadaTruck + (arrayFrotas[1]?.cargaKg * e.target.value) > caixas) {
            setQtdSelecionadaTruck(caixas)
            setAlertTruck(`Há ${(qtdSelecionadaTruck + (arrayFrotas[1]?.cargaKg * e.target.value) - caixas) / 1000} ton remanescentes nas frotas contratadas`)
          } else {
            setAlertTruck("")
            setQtdSelecionadaTruck(qtdSelecionadaTruck + (arrayFrotas[1]?.cargaKg * e.target.value))
          }
          setCaixasRestantes(caixasRestantes - (arrayFrotas[1]?.cargaKg * e.target.value) > caixasRestantes ? 0 : caixasRestantes - (arrayFrotas[1]?.cargaKg * e.target.value))
        } else {
          setQtdSelecionadaTruck(qtdSelecionadaTruck + caixasRestantes)
          setCaixasRestantes(0)
        }

      } else {

        setQtdSelecionadaTruck(qtdSelecionadaTruck - arrayFrotas[1]?.cargaKg <= 0 ? 0 : qtdSelecionadaTruck - arrayFrotas[1]?.cargaKg)
        setCaixasRestantes(caixasRestantes + arrayFrotas[1]?.cargaKg >= caixas ? caixas : caixasRestantes + arrayFrotas[1]?.cargaKg)

      }

    } else {

      setAlertTruck("")
      setQtdSelecionadaTruck(0)
      setCaixasRestantes(caixas)

    }
  }

  const handleFrotaCarreta = (e) => {
    setFrotaCarreta(e.target.value)

    if (e.target.value >= 1) {
      if (e.target.value > frotaCarreta) {

        if (caixasRestantes > arrayFrotas[2]?.cargaKg) {
          if (qtdSelecionadaCarreta + (arrayFrotas[2]?.cargaKg * e.target.value) > caixas) {
            setQtdSelecionadaCarreta(caixas)
            setAlertCarreta(`Há ${(qtdSelecionadaCarreta + (arrayFrotas[2]?.cargaKg * e.target.value) - caixas) / 1000} ton remanescentes nas frotas contratadas`)
          } else {
            setAlertCarreta("")
            setQtdSelecionadaCarreta(qtdSelecionadaCarreta + (arrayFrotas[2]?.cargaKg * e.target.value))
          }
          setCaixasRestantes(caixasRestantes - (arrayFrotas[2]?.cargaKg * e.target.value) > caixasRestantes ? 0 : caixasRestantes - (arrayFrotas[2]?.cargaKg * e.target.value))
        } else {
          setQtdSelecionadaCarreta(qtdSelecionadaCarreta + caixasRestantes)
          setCaixasRestantes(0)
        }

      } else {

        setQtdSelecionadaCarreta(qtdSelecionadaCarreta - arrayFrotas[2]?.cargaKg <= 0 ? 0 : qtdSelecionadaCarreta - arrayFrotas[2]?.cargaKg)
        setCaixasRestantes(caixasRestantes + arrayFrotas[2]?.cargaKg >= caixas ? caixas : caixasRestantes + arrayFrotas[2]?.cargaKg)

      }

    } else {

      setAlertCarreta("")
      setQtdSelecionadaCarreta(0)
      setCaixasRestantes(caixas)

    }
  }

  useEffect(() => {
    getApprovedNegociation()
  }, [])

  function handleTotalCif() {

    if (isNaN(parseFloat(frota3x4) * 950 + parseFloat(frotaTruck) * 2000 + parseFloat(frotaCarreta) * 3000)) {
      return 0
    } else {
      return parseFloat(frota3x4) * 950 + parseFloat(frotaTruck) * 2000 + parseFloat(frotaCarreta) * 3000
    }

  }

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/shipping_button.svg"
          title="Logística"
          subTitle="(Frota e Frete)"
          style={["", "", "", "", "selection"]}
        />
        <TopShipping />
        <SubHeader
          style={["selection", "", "", "", ""]}
          path1="toolsShippingSausage"
          path2="toolsShippingChicken"
          path3="toolsShippingChickenCut"
          path4="toolsShippingFries"
        />
        <MainContainer>
          <h2>
            Produto <span>Linguiça Salsichão</span>
          </h2>
          <SubTitle>
            <img src="./images/shipping_icon.svg" alt="shipping_icon" />
            Frete
          </SubTitle>
          <h2>
            Negociações Fechadas
          </h2>


          <RequestContainer>
            {/* <SubTitle>
                  <img src="./images/ticket.svg" alt="ticket" />
               
                  </div>
                </SubTitle> */}
            {
              approvedNegociations?.map(item => {
                return (
                  <FirstRequestContainer >
                    <NegociationAproved onClick={() => {
                      setSelectedMarketNegociation(item)
                      setCaixas(item.itens?.find(a => a.produto.produto === 7)?.quantidade)
                    }}>
                      {item.supermercado.nome}
                    </NegociationAproved>

                    {selectedMarketNegociation.visitaNegociacao === item.visitaNegociacao &&

                      <>
                        <div>
                          <small>Quantidade de Caixas</small>
                          <input value={item.itens?.find(a => a.produto.produto === 7)?.quantidade} disabled type="number" placeholder="0" />
                        </div>
                        <p>
                          R$<input value={item.itens?.find(a => a.produto.produto === 7)?.total} disabled type="number" placeholder="0" /><img src="./images/box.svg" alt="box" />
                        </p>
                        <div className="buttons">
                          <ButtonContainer>
                            <p>á vista</p>
                            {inCash ? (
                              <button
                                className="checked"
                                onClick={() => handleDeadline("inCash")}
                              />
                            ) : (
                              <button onClick={() => handleDeadline("inCash")} />
                            )}
                          </ButtonContainer>
                          <ButtonContainer>
                            <p>30 dias</p>
                            {thirtyDays ? (
                              <button
                                className="checked"
                                onClick={() => handleDeadline("thirtyDays")}
                              />
                            ) : (
                              <button onClick={() => handleDeadline("thirtyDays")} />
                            )}
                          </ButtonContainer>
                        </div>
                      </>
                    }


                  </FirstRequestContainer>

                )
              })}
          </RequestContainer>
          <h2 style={{ marginTop: "-70px" }}>Caixas a serem transportadas: {caixas}</h2>
          <ContainerCard>
            <Header>
              <img src={`./images/${arrayFrotas[0].img}`} alt="shipping_icon" />
              <h3>N° de Frotas</h3>
              <input value={frota3x4} onChange={(e) => handleFrota3x4(e)} placeholder="0" />
            </Header>
            <MiddleContent>
              <h3>
                Capacidade de <span>Caixas</span>
              </h3>
              <p>
                {arrayFrotas[0]?.cargaKg / 1000} <span>ton</span>
                <img src="./images/shipping_icon.svg" alt="shipping_icon" />
              </p>
            </MiddleContent>
            <MiddleContent>
              <h3>
                Custo unitário de <span>Caixas</span>
              </h3>
              <p>
                <span>R$</span> {arrayFrotas[0]?.cargaCaixas} <img src="./images/cifrao.svg" alt="cifrao" />
              </p>
            </MiddleContent>
            <Footer>
              <h3>
                Carga <span>Selecionada</span>
              </h3>
              <p>
                {qtdSelecionada} <img src="./images/unit_cost.svg" alt="unit_cost" />
              </p>
            </Footer>
            {caixasRestantes > 0 &&
              <Footer>
                Caixas restantes:{caixasRestantes}
              </Footer>
            }
            <Footer>
              {alert3x4}
            </Footer>
          </ContainerCard>
          <ContainerCard>
            <Header>
              <img src={`./images/${arrayFrotas[1].img}`} alt="shipping_icon" />
              <h3>N° de Frotas</h3>
              <input value={frotaTruck} onChange={(e) => handleFrotaTruck(e)} placeholder="0" />
            </Header>
            <MiddleContent>
              <h3>
                Capacidade de <span>Caixas</span>
              </h3>
              <p>
                {arrayFrotas[1]?.cargaKg / 1000} <span>ton</span>
                <img src="./images/shipping_icon.svg" alt="shipping_icon" />
              </p>
            </MiddleContent>
            <MiddleContent>
              <h3>
                Custo unitário de <span>Caixas</span>
              </h3>
              <p>
                <span>R$</span> {arrayFrotas[1]?.cargaCaixas} <img src="./images/cifrao.svg" alt="cifrao" />
              </p>
            </MiddleContent>
            <Footer>
              <h3>
                Carga <span>Selecionada</span>
              </h3>
              <p>
                {qtdSelecionadaTruck} <img src="./images/unit_cost.svg" alt="unit_cost" />
              </p>
            </Footer>
            {caixasRestantes > 0 &&
              <Footer>
                Caixas restantes:{caixasRestantes}
              </Footer>
            }
            <Footer>
              {alertTruck}
            </Footer>
          </ContainerCard>
          <ContainerCard>
            <Header>
              <img src={`./images/${arrayFrotas[2].img}`} alt="shipping_icon" />
              <h3>N° de Frotas</h3>
              <input value={frotaCarreta} onChange={(e) => handleFrotaCarreta(e)} placeholder="0" />
            </Header>
            <MiddleContent>
              <h3>
                Capacidade de <span>Caixas</span>
              </h3>
              <p>
                {arrayFrotas[2]?.cargaKg / 1000} <span>ton</span>
                <img src="./images/shipping_icon.svg" alt="shipping_icon" />
              </p>
            </MiddleContent>
            <MiddleContent>
              <h3>
                Custo unitário de <span>Caixas</span>
              </h3>
              <p>
                <span>R$</span> {arrayFrotas[2]?.cargaCaixas} <img src="./images/cifrao.svg" alt="cifrao" />
              </p>
            </MiddleContent>
            <Footer>
              <h3>
                Carga <span>Selecionada</span>
              </h3>
              <p>
                {qtdSelecionadaCarreta} <img src="./images/unit_cost.svg" alt="unit_cost" />
              </p>
            </Footer>
            {caixasRestantes > 0 &&
              <Footer>
                Caixas restantes:{caixasRestantes}
              </Footer>
            }npm
            <Footer>
              {alertCarreta}
            </Footer>
          </ContainerCard>

          <TotalsContainer>
            <img src="./images/unit_cost.svg" alt="unit_cost" />
            <div>
              <h4>Carga total</h4>
              <p>
                {caixas} <img src="./images/box.svg" alt="box" />
              </p>
            </div>
            <p>
              {caixas} <img src="./images/kg.svg" alt="kg" />
            </p>
          </TotalsContainer>

          <TotalsDifferent>
            <img src="./images/shipping_button.svg" alt="shipping_button" />
            <h4>Frete total</h4>
            <p>{handleTotalCif()}</p>
          </TotalsDifferent>

          {/* <TotalsDifferent>
            <img src="./images/ticket.svg" alt="ticket" />
            <h4>Preço CIF</h4>
            <p>
              {handleTotalCif()} <img src="./images/cifrao.svg" alt="cifrao" />
            </p>
          </TotalsDifferent> */}
        </MainContainer>
        <FooterButton onHandle={handleShipping} text="Confirmar" />
      </SizeContainer>
    </Container>
  );
};
export default ToolsShippingSausage;
